import { render, staticRenderFns } from "./ReviewTab.vue?vue&type=template&id=6b6ab577&"
import script from "./ReviewTab.vue?vue&type=script&lang=js&"
export * from "./ReviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports